import CheckAssignmentTable from "./CheckAssignmentTable";
import LoadingSpinner from "../../shared-components/LoadingSpinner";
import { useAssignmentHooks } from "./AssignmentHooks";
import { LoadedSince } from "../../shared-components/LoadedSince";
import { AssignmentDomain, AssignmentModel } from "./models";

type Props = {};

const TaskAssignment = (props: Props) => {
  const { isLoading, headers, data, loadActorInfo, updatedAt } =
    useAssignmentHooks("workflow");

  return (
    <div>
      <div className="flex justify-end">
        <LoadedSince
          reportData={{ timestamp: updatedAt }}
          onClear={() => {
            loadActorInfo();
          }}
          className="mb-4"
        />
      </div>
      {isLoading && <LoadingSpinner />}
      {!isLoading && (
        <CheckAssignmentTable
          headers={headers}
          data={data}
          domain={AssignmentDomain.workflow}
          model={AssignmentModel.WorkflowStepConfigs}
        />
      )}
    </div>
  );
};

export default TaskAssignment;
